import * as React from "react";
import { cx } from "utils/join-classnames";
import styles from "./CheckBox.module.scss";

type Props = {
    value: string;
    theme: string;
    onChange(value: boolean): void;
    title: string;
    id: string;
    valid?: boolean;
    disabled?: boolean;
    className?: string;
    checkboxPos?: "left" | "right";
};

const CheckBox: React.FC<Props> = ({
    value,
    theme,
    onChange,
    id,
    valid,
    disabled = false,
    title,
    className,
    checkboxPos,
}: Props) => (
    <div
        className={cx(
            className,
            theme === "light" ? styles.light : null,
            disabled ? styles.disabled : null,
        )}
    >
        <input
            type="checkbox"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onChange(e.target.checked)
            }
            className={cx(styles.checkbox)}
            value={value}
            id={id}
            disabled={disabled}
            checked={value === "true"}
        />
        {checkboxPos !== "right" && (
            <label htmlFor={id} className={styles.checkbox__label}>
                <div
                    className={cx(
                        styles.checkbox__label__box,
                        !valid ? styles.checkbox__invalid : null,
                    )}
                />
                <span>{title}</span>
            </label>
        )}
        {checkboxPos === "right" && (
            <label htmlFor={id} className={styles.checkbox__label}>
                <span>{title}</span>
                <div
                    className={cx(
                        styles.checkbox__label__box,
                        styles.checkbox__label__boxRight,
                        !valid ? styles.checkbox__invalid : null,
                    )}
                />
            </label>
        )}
    </div>
);

export default CheckBox;
